'use client'

import { HoverCard, HoverCardTrigger, HoverCardContent } from '@/app/components/ui/hover-card';
import { AUCTION_TITLE_TRUNCATION_LENGTH } from '@/lib/constants';
import { truncateString } from '@/lib/utils';
import { InfoCircledIcon } from '@radix-ui/react-icons';
import { Flex, Text } from '@radix-ui/themes';
import React from 'react';

interface Props {
  auctionTitle: string;
}

const PreviewBanner = ({ auctionTitle }: Props) => {
  return (
    <HoverCard openDelay={100}>
      <HoverCardTrigger>
        <Flex className="bg-amber-100 rounded-lg px-3 h-8" align="center">
          <InfoCircledIcon className="w-4 h-4 mr-2" />
          <Text className="font-medium text-sm">
            {truncateString(auctionTitle, AUCTION_TITLE_TRUNCATION_LENGTH)} - Admin Preview
          </Text>
        </Flex>
      </HoverCardTrigger>
      <HoverCardContent className="w-80 text-sm">
        This auction has not yet been published. This is a pre-publish view that refects the current state of the auction, and any changes made in the admin dashboard will appear here.<br /><br />

        Once this auction is published, buyers will see what&nbsp;s here.
      </HoverCardContent>
    </HoverCard>
  );
}

export default PreviewBanner
